// list_name for the Campaign Status Listentry
export const campaignStatusListentryListName = 'campaignStatus';

// Status categories for the 'CampaignStatus' listentry
export const statusCategoryStart = 'start';
export const statusCategoryOngoing = 'ongoing';
export const statusCategoryFinal = 'final';
